import React from 'react'
import './Toast.css'

const styles = {
  error: {
    fontSize: '16px',
    fontWeight: '300',
    lineHeight: '24px',
    opacity: '1',
    background: '#E66772',
    padding: '15px 16px 16px 25px',
    maxWidth: '570px',
    boxShadow: '0 2px 4px rgba(20,31,51,.1)',
    borderRadius: '8px',
    color: '#FFF',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  close: {
    float: 'right',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    verticalAlign: 'middle',
    opacity: '.5'
  },
  closeIcon: {
    cursor: 'pointer',
    fontSize: '20px',
    color: 'white'
  },
  stack: {
    position: 'fixed',
    zIndex: '9999',
    bottom: '10px',
    left: '10px'
  },
  notif: {
    boxShadow: 'rgba(20, 31, 51, 0.1) 0px 2px 4px',
    animationName: 'fade-in-up',
    animationTimingFunction: 'cubic-bezier(0.125, 0.5, 0.125, 1)',
    opacity: '0',
    marginBottom: '15px',
    backgroundColor: 'rgb(36, 174, 242)',
    cursor: 'pointer',
    padding: '8px 15px 10px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left 10px center'
  },
  item: {
    animationDuration: '0.5s',
    color: 'rgb(255, 255, 255)',
    animationIterationCount: '1',
    animationDirection: 'normal',
    animationFillMode: 'forwards',
    perspective: '1000px',
    borderRadius: '4px'
  },
  success: {
    backgroundColor: 'rgb(40, 219, 103)'
  },
  warning: {
    backgroundColor: 'rgb(230, 103, 114)'
  },
  message: {
    paddingLeft: '15px'
  }
}

export const SFToast = ({ className, errorStyle, message, onClick }) => {
  const toastStyle = { ...styles.error, ...errorStyle }
  return (
    <div className='invalid' style={toastStyle}>
      {message}
      <div className='error-close' style={styles.close} onClick={onClick}>
        <i style={styles.closeIcon} className='fa fa-times' />
      </div>
    </div>
  )
}

export const SFNotification = ({ className, type, message, onClick, icon }) => {
  const style = { ...styles.item, ...styles.notif, ...styles[type] }
  return (
    <div style={style} className={`toast-item ${type}`}>
      {icon || null}
      <span style={icon ? styles.message : {}}>{message}</span>
    </div>
  )
}

export const SFStack = ({ toasts }) => {
  return (
    <div style={styles.stack} className='toast-stack'>
      {toasts}
    </div>
  )
}

const SuccessToast = ({ message, onClick }) => {
  return (
    <SFNotification
      className=''
      type='success'
      message={message}
      onClick={onClick}
      icon={<i className='fa fa-check' />}
    />
  )
}

const ErrorToast = ({ message, onClick }) => {
  return (
    <SFNotification
      className=''
      type='warning'
      message={message}
      onClick={onClick}
      icon={<i className='fa fa-exclamation-circle' />}
    />
  )
}

export const GetSuccessNotif = () => {
  return <SuccessToast message='Changes saved!' onClick={() => {}} />
}

export const GetErrorNotif = message => {
  return (
    <ErrorToast message={`Error encountered: ${message}`} onClick={() => {}} />
  )
}

export const GetNotif = () => {
  return (
    <SFNotification
      className=''
      message='Preferences updated.'
      onClick={() => {}}
    />
  )
}
